export const PROFILE_QUERY_KEY = () => ["profile"];

export const USER_ADDRESSES_QUERY_KEY = () => ["addresses"];
